import axios from "axios";
import { API_ENDPOINT } from "@/utils/misc";

export const get = (from, to) => {
  return axios.get(`${API_ENDPOINT()}/hr-notifications`, {
    params: { from, to },
  });
};
